// extracted by mini-css-extract-plugin
export default {"infiniteFeedPosts":"Posts_infiniteFeedPosts__5bqjm","post":"Posts_post__dd7Mz","discoverBlock":"Posts_discoverBlock__-LJCN"};